module.exports = {
          srcSet: __webpack_public_path__ + "bc0adbcef6993b7d471bd75a1b20d057-1680.png"+" 1680w",
          images:[ {path: __webpack_public_path__ + "bc0adbcef6993b7d471bd75a1b20d057-1680.png",width: 1680,height: 549}],
          src: __webpack_public_path__ + "bc0adbcef6993b7d471bd75a1b20d057-1680.png",
          toString:function(){return __webpack_public_path__ + "bc0adbcef6993b7d471bd75a1b20d057-1680.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAADCAYAAACqPZ51AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAWklEQVR4nC3MsQnCUABF0SyQSMDGOZxACKQU50lhOhVsrdJlk5TBORzABd4JH9LfeypcMGNEhyZJneSAE1qcK/zwT7Lijn6fnpjwxlLCB74oyhG3IuCKD14YNmubZf0v4LiLAAAAAElFTkSuQmCC",
          width: 1680,
          height: 549
        }